import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Shop from './pages/Shop';
import ShopCanada from './pages/ShopCanada';
import Contact from './pages/Contact';
import Subscriptions from './pages/Subscriptions';
import BulkOrder from './pages/BulkOrder';
import Auth from './pages/Auth';
import Account from './pages/Account';
import Admin from './pages/Admin';
import Checkout from './pages/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutVerify from './pages/CheckoutVerify';
import GuestCheckout from './pages/GuestCheckout';
import ShippingInfo from './pages/ShippingInfo';
import { CartProvider } from './context/CartContext';
import { CurrencyProvider } from './context/CurrencyContext';

const App: React.FC = () => {
  return (
    <CurrencyProvider>
      <CartProvider>
        <Router>
          <div className="flex flex-col min-h-screen">
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about-us" element={<About />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop-canada" element={<ShopCanada />} />
                <Route path="/shipping-info" element={<ShippingInfo />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/subscriptions" element={<Subscriptions />} />
                <Route path="/bulk-order" element={<BulkOrder />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/account" element={<Account />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/checkout/verify" element={<CheckoutVerify />} />
                <Route path="/guest-checkout" element={<GuestCheckout />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </CartProvider>
    </CurrencyProvider>
  );
};

export default App;